import { ComponentRef, Injectable } from '@angular/core';
import { WidgetDock } from '../../util/WidgetDock';
import { WidgetWrapperComponent } from '../widget-wrapper/widget-wrapper.component';
import { InformationviewComponent } from './informationview.component';
import { SpacerHelper } from './spacerHelper';

@Injectable()
export class InformationViewWidgetDock extends WidgetDock {
  protected removeFromDom(wrapperComponentRef: ComponentRef<WidgetWrapperComponent>): void {
    SpacerHelper.removeLeftSpacerFromDOM(wrapperComponentRef, InformationviewComponent.WIDGET_CONTAINER_ID);
    this.removeWrapperFromDOM(wrapperComponentRef);
  }
}
